

function toggleSizeChart(el) {
  const mainProduct = el.closest("product-component");
  if (!mainProduct) return;
  
  const currentChart = mainProduct.querySelector("#sizeChart");
  if (!currentChart) return;
  
  currentChart.classList.toggle("active");
  
  if (currentChart.classList.contains("active")) {
    const closeOnScroll = () => {
      currentChart.classList.remove("active");
      document.removeEventListener("scroll", closeOnScroll);
    };
    
    document.addEventListener("scroll", closeOnScroll, { passive: true });
  }
}

function togglequickaddsizeChart(el) {
  const quickmainProduct = el.closest(".cust-quick-add");
  if (!quickmainProduct) return;
  
  
  const quickcurrentChart = quickmainProduct.querySelector("#quick-add-sizeChart");
  if (!quickcurrentChart) return;
  quickcurrentChart.classList.toggle("active");

  if (quickcurrentChart.classList.contains("active")) {
    const closeOnScroll = () => {
      quickcurrentChart.classList.remove("active");
      document.removeEventListener("scroll", closeOnScroll);
    };

    document.addEventListener("scroll", closeOnScroll, { passive: true });
  }
}

// acoodian  

  function toggleAccordionnits(element) {
    const blocknew = element.parentElement;
    const contentnew = blocknew.querySelector('.nits-accordian-content');
    const iconnew = element.querySelector('.accordion-icon');

    const allBlocksnew = document.querySelectorAll('.nits-accordian-block');

    allBlocksnew.forEach((otherBlocknew) => {
      if (otherBlocknew !== blocknew) {
        const otherContentnew = otherBlocknew.querySelector('.nits-accordian-content');
        const otherIconnew = otherBlocknew.querySelector('.accordion-icon');
        otherContentnew.style.maxHeight = null;
        otherIconnew.textContent = '+';
        otherBlocknew.classList.remove('active');
      }
    });

    blocknew.classList.toggle('active');

    if (contentnew.style.maxHeight) {
      contentnew.style.maxHeight = null;
      iconnew.textContent = '+';
    } else {
      contentnew.style.maxHeight = contentnew.scrollHeight + 'px';
      iconnew.textContent = '−';
    }
  }

// acoodian  

// z-index
const observer = new MutationObserver(function () {
  const isActive = document.querySelector('.cust-quick-add.is-active');

  document
    .querySelectorAll('[data-template="collection"] .product-grid-container')
    .forEach(function (element) {
      element.style.zIndex = isActive ? '15' : '';
    });
});

observer.observe(document.body, {
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});

// z-index


// variant-chnage
(function () {
  'use strict';

  if (window.__CUST_QUICK_ADD_V8__) return;
  window.__CUST_QUICK_ADD_V8__ = true;

  /* =========================================================
    SETTINGS
  ========================================================= */

  const CUST_MAX_QTY = 10;
  const CUST_AUTO_CLOSE_MS = 6000; // auto close success popup after 5s

  const maxReachedVariants = new Set(); // per variant id
  const pendingVariantAdds = new Set(); // productId:variantId


  /* =========================================================
    BASIC HELPERS
  ========================================================= */

  function getContainer(element) {
    return element ? element.closest('.cust-quick-add') : null;
  }

  function getRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  function formatMoney(cents, moneyFormat) {
    cents = Number(cents || 0);

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, moneyFormat || '');
      } catch (error) {
        console.warn('Cust Quick Add: Shopify.formatMoney error', error);
      }
    }

    return (
      'Rs.' +
      (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }

  function fire(target, name, detail) {
    try {
      target.dispatchEvent(
        new CustomEvent(name, { bubbles: true, detail: detail })
      );
    } catch (error) {}
  }


  /* =========================================================
    LOADER  (NEW)
  ========================================================= */

  function setLoading(container, isLoading) {
    if (!container) return;

    const loader = container.querySelector('.pdp-loader-screen');

    if (loader) {
      loader.classList.toggle('loading', !!isLoading);
    }

    container.classList.toggle('is-loading', !!isLoading);
  }


  /* =========================================================
    AUTO CLOSE TIMER  (NEW)
  ========================================================= */

  function clearAutoClose(container) {
    if (container && container.__custAutoCloseTimer) {
      clearTimeout(container.__custAutoCloseTimer);
      container.__custAutoCloseTimer = null;
    }
  }

  function startAutoClose(container) {
    clearAutoClose(container);

    container.__custAutoCloseTimer = setTimeout(function () {
      container.__custAutoCloseTimer = null;

      const popup = container.querySelector('.cust-quick-add-success-popup');

      // Only close if success popup is still open
      if (popup && popup.classList.contains('active')) {
        closeSuccess(container);
      }
    }, CUST_AUTO_CLOSE_MS);
  }


  /* =========================================================
    VARIANTS
  ========================================================= */

  function getVariants(container) {
    if (!container) return [];

    const json = container.querySelector('[data-cust-quick-add-variants]');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent || '[]');
    } catch (error) {
      console.error('Cust Quick Add: variant JSON error', error);
      return [];
    }
  }

  function getPicker(container) {
    return container
      ? container.querySelector('.cust-quick-add-variant-picker')
      : null;
  }

  function getSelectedInputs(picker) {
    if (!picker) return [];

    const seen = new Set();
    const result = [];

    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      if (!seen.has(input.name)) {
        seen.add(input.name);
        result.push(input);
      }
    });

    return result;
  }

  // Number of options a variant has (Color + Size = 2, Size only = 1)
  function getOptionCount(container) {
    const variants = getVariants(container);

    return variants.length && variants[0].options
      ? variants[0].options.length
      : 0;
  }

  function findVariant(container) {
    const picker = getPicker(container);
    if (!picker) return null;

    const selectedInputs = getSelectedInputs(picker);

    // Do not find a variant until every option is selected
    if (
      !selectedInputs.length ||
      selectedInputs.length !== getOptionCount(container)
    ) {
      return null;
    }

    const selectedOptions = selectedInputs.map(function (input) {
      return String(input.value).trim();
    });

    return (
      getVariants(container).find(function (variant) {
        if (!variant || !variant.options) return false;
        if (variant.options.length !== selectedOptions.length) return false;

        return variant.options.every(function (option, index) {
          return String(option).trim() === selectedOptions[index];
        });
      }) || null
    );
  }

  function getInitialVariant(container) {
    const variants = getVariants(container);
    if (!variants.length) return null;

    return (
      variants.find(function (variant) {
        return variant.available !== false;
      }) ||
      variants[0] ||
      null
    );
  }


  /* =========================================================
    ACTIVE STATE
  ========================================================= */

  function updateActiveState(container) {
    const picker = getPicker(container);
    if (!picker) return;

    picker
      .querySelectorAll('.cust-quick-add-option-label')
      .forEach(function (label) {
        const input = label.querySelector('input[type="radio"]');
        if (!input) return;
        label.classList.toggle('is-selected', input.checked);
      });

    picker
      .querySelectorAll('.cust-quick-add-fieldset')
      .forEach(function (fieldset) {
        const input = fieldset.querySelector('input[type="radio"]:checked');
        const text = fieldset.querySelector('.cust-quick-add-current-value');

        if (text) {
          text.textContent = input ? input.value : '';
        }
      });
  }


  /* =========================================================
    SALE / SOLD TAGS
  ========================================================= */

  function updateVariantTags(container, variant) {
    if (!container) return;

    const saleTag = container.querySelector('[data-pdp-tag="sale"]');
    const soldTag = container.querySelector('[data-pdp-tag="sold"]');

    if (!saleTag && !soldTag) return;

    const price = Number(variant && variant.price ? variant.price : 0);
    const compareAtPrice = Number(
      variant && variant.compare_at_price ? variant.compare_at_price : 0
    );

    const isSale = compareAtPrice > price && price > 0;
    const isSold = !!(variant && variant.available === false);

    if (saleTag) {
      saleTag.style.display = isSale ? '' : 'none';
      saleTag.classList.toggle('is-active', isSale);
      saleTag.setAttribute('aria-hidden', isSale ? 'false' : 'true');
    }

    if (soldTag) {
      soldTag.style.display = isSold ? '' : 'none';
      soldTag.classList.toggle('is-active', isSold);
      soldTag.setAttribute('aria-hidden', isSold ? 'false' : 'true');
    }

    container.classList.toggle('has-sale', isSale);
    container.classList.toggle('is-sold', isSold);
  }


  /* =========================================================
    PRICE
  ========================================================= */

  function buildPriceHTML(price, comparePrice, moneyFormat) {
    price = Number(price || 0);
    comparePrice = Number(comparePrice || 0);

    if (comparePrice > price && price > 0) {
      return `
        <div class="price price--on-sale">
          <div class="price__container">
            <div class="price__sale">
              <span class="price-item price-item--sale">${formatMoney(price, moneyFormat)}</span>
              <span class="price-item price-item--regular">${formatMoney(comparePrice, moneyFormat)}</span>
            </div>
          </div>
        </div>
      `;
    }

    return `
      <div class="price">
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular">${formatMoney(price, moneyFormat)}</span>
          </div>
        </div>
      </div>
    `;
  }

  function updatePrice(container, variant) {
    const price = container.querySelector('[data-quick-add-price]');
    if (!price || !variant) return;

    price.innerHTML = buildPriceHTML(
      Number(variant.price || 0),
      Number(variant.compare_at_price || 0),
      container.dataset.moneyFormat || ''
    );
  }


  /* =========================================================
    ERROR MESSAGE
  ========================================================= */

  function getMaxError(container) {
    return container
      ? container.querySelector('.nits-horizon-max-error')
      : null;
  }

  function showMaxError(container, message) {
    const errorBox = getMaxError(container);
    if (!errorBox) return;

    const errorText = errorBox.querySelector('.cart-item__error-text');

    if (errorText) {
      errorText.textContent =
        message || 'Maximum quantity reached for this variant.';
    }

    errorBox.classList.remove('hidden');
    errorBox.setAttribute('aria-hidden', 'false');
  }

  function hideMaxError(container) {
    const errorBox = getMaxError(container);
    if (!errorBox) return;

    errorBox.classList.add('hidden');
    errorBox.setAttribute('aria-hidden', 'true');

    const errorText = errorBox.querySelector('.cart-item__error-text');
    if (errorText) errorText.textContent = '';
  }


  /* =========================================================
    PICKER RESET
  ========================================================= */

  function saveOriginalPicker(container) {
    if (!container) return;

    const picker = getPicker(container);
    if (!picker) return;

    if (!container.__custOriginalPickerHTML) {
      container.__custOriginalPickerHTML = picker.outerHTML;
    }
  }

  function createFreshPicker(container) {
    if (!container) return null;

    saveOriginalPicker(container);

    const currentPicker = getPicker(container);
    const originalHTML = container.__custOriginalPickerHTML;

    if (!originalHTML) return currentPicker;

    if (currentPicker) currentPicker.remove();

    const wrapper = document.createElement('div');
    wrapper.innerHTML = originalHTML.trim();

    const freshPicker = wrapper.firstElementChild;
    if (!freshPicker) return null;

    freshPicker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.checked = false;
      input.removeAttribute('checked');
      input.dataset.previousChecked = 'false';
      input.dataset.currentChecked = 'false';
    });

    freshPicker
      .querySelectorAll('.cust-quick-add-option-label')
      .forEach(function (label) {
        label.classList.remove('is-selected');
        label.classList.remove('is-max-reached');
      });

    freshPicker
      .querySelectorAll('.cust-quick-add-current-value')
      .forEach(function (element) {
        element.textContent = '';
      });

    const variantsWrapper = container.querySelector('.cust-quick-add-variants');
    if (!variantsWrapper) return null;

    variantsWrapper.appendChild(freshPicker);

    updateActiveState(container);

    // Initial variant is used only for price and tags (NOT selected)
    const initialVariant = getInitialVariant(container);

    if (initialVariant) {
      updatePrice(container, initialVariant);
      updateVariantTags(container, initialVariant);
    } else {
      updateVariantTags(container, null);
    }

    hideMaxError(container);

    return freshPicker;
  }


  /* =========================================================
    OVERLAY
  ========================================================= */

  function getExternalOverlay(container) {
    if (!container) return null;

    const productId = container.dataset.productId;

    if (productId) {
      try {
        const overlay = document.querySelector(
          '.cust-quick-add-overlayer[data-product-id="' +
            CSS.escape(String(productId)) +
            '"]'
        );
        if (overlay) return overlay;
      } catch (error) {}
    }

    const previous = container.previousElementSibling;
    if (previous && previous.classList.contains('cust-quick-add-overlayer')) {
      return previous;
    }

    const next = container.nextElementSibling;
    if (next && next.classList.contains('cust-quick-add-overlayer')) {
      return next;
    }

    return null;
  }


  /* =========================================================
    RESET / CLOSE
  ========================================================= */

  function resetQuickAdd(container) {
    if (!container) return;

    clearAutoClose(container); // NEW
    setLoading(container, false); // NEW

    container.dataset.adding = 'false';
    container.classList.remove('cust-quick-add-success-active');

    const popup = container.querySelector('.cust-quick-add-success-popup');
    if (popup) popup.classList.remove('active');

    const internalOverlay = container.querySelector('.cust-quick-add-overlay');
    if (internalOverlay) internalOverlay.classList.remove('active');

    hideMaxError(container);
    createFreshPicker(container);
  }

  function closeSuccess(container) {
    if (!container) return;

    resetQuickAdd(container);

    container.classList.remove('is-active');

    const externalOverlay = getExternalOverlay(container);
    if (externalOverlay) externalOverlay.classList.remove('is-active');

    document.body.classList.remove('cust-quick-add-body-open');
  }

  function closeAllSuccess() {
    document.querySelectorAll('.cust-quick-add').forEach(function (container) {
      closeSuccess(container);
    });

    document
      .querySelectorAll('.cust-quick-add-overlayer.is-active')
      .forEach(function (overlay) {
        overlay.classList.remove('is-active');
      });

    document.body.classList.remove('cust-quick-add-body-open');
  }


  /* =========================================================
    SUCCESS POPUP
  ========================================================= */

  function openSuccess(container, variant, addedItem) {
    if (!container || !variant) return;

    const popup = container.querySelector('.cust-quick-add-success-popup');
    if (!popup) return;

    const internalOverlay = container.querySelector('.cust-quick-add-overlay');

    const title = container.dataset.productTitle || '';
    const fallbackImage = container.dataset.productImage || '';
    const image = addedItem && addedItem.image ? addedItem.image : fallbackImage;

    const imageElement = popup.querySelector('.cust-quick-add-product-image img');
    const nameElement = popup.querySelector('.cust-quick-add-product-name');
    const variantElement = popup.querySelector('.cust-quick-add-product-variant');
    const priceElement = popup.querySelector('.cust-quick-add-product-price');

    if (imageElement) {
      imageElement.src = image || '';
      imageElement.alt = title;
    }

    if (nameElement) nameElement.textContent = title;
    if (variantElement) variantElement.textContent = `size : ${variant.title} / ${+variant.title + 34}` || '';

    if (priceElement) {
      priceElement.innerHTML = buildPriceHTML(
        Number(variant.price || 0),
        Number(variant.compare_at_price || 0),
        container.dataset.moneyFormat || ''
      );
    }

    container.classList.add('cust-quick-add-success-active');
    popup.classList.add('active');
    if (internalOverlay) internalOverlay.classList.add('active');

    document.body.classList.add('cust-quick-add-body-open');

    // NEW: auto close after 5s
    startAutoClose(container);
  }


  /* =========================================================
    CART COUNT
  ========================================================= */

  function updateCartCount(cart) {
    if (!cart) return;

    const count = Number(cart.item_count || 0);

    const selectors = [
      '[ref="cartBubbleCount"]',
      '[ref="cartCount"]',
      '[data-testid="cart-bubble"]',
      '[data-testid="cart-count"]',
      '[data-cart-count]',
      '.cart-count-bubble .cart-count',
      '.cart-count-bubble span',
      '.cart-bubble__text',
      '.cart-bubble__count',
      '.cart-count'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (element) {
      const childSpan = element.querySelector('span');

      if (childSpan && !element.matches('.cart-count')) {
        childSpan.textContent = count;
      } else {
        element.textContent = count;
      }

      element.setAttribute('data-cart-count', String(count));
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      const numberElement =
        bubble.querySelector('.cart-count') ||
        bubble.querySelector('[data-cart-count]') ||
        bubble.querySelector('span');

      if (numberElement) numberElement.textContent = count;

      bubble.setAttribute('data-count', String(count));
      bubble.classList.toggle('hidden', count === 0);
    });

    document.documentElement.classList.toggle('cart-has-items', count > 0);
    document.body.classList.toggle('cart-has-items', count > 0);

    window.custQuickAddCartState = cart;

    fire(document, 'cust-quick-add:cart-count-updated', {
      count: count,
      cart: cart
    });

    fire(document, 'cart:count-updated', {
      count: count,
      cart: cart,
      source: 'cust-quick-add'
    });
  }


  /* =========================================================
    GET CART
  ========================================================= */

  async function getCart() {
    const response = await fetch(getRoot() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Unable to get cart');

    return response.json();
  }


  /* =========================================================
    VARIANT QUANTITY / MAX
  ========================================================= */

  function getVariantQuantityInCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (String(item.variant_id) === String(variantId)) {
        return total + Number(item.quantity || 0);
      }
      return total;
    }, 0);
  }

  function getVariantMaxQuantity(variant) {
    let maxQuantity = CUST_MAX_QTY;

    if (
      variant &&
      variant.inventory_management &&
      Number(variant.inventory_quantity) >= 0
    ) {
      maxQuantity = Math.min(CUST_MAX_QTY, Number(variant.inventory_quantity));
    }

    return maxQuantity;
  }

  function markVariantMaxReached(container, variantId) {
    if (!variantId) return;

    const id = String(variantId);
    maxReachedVariants.add(id);

    if (!container) return;

    const currentVariant = findVariant(container);
    if (!currentVariant || String(currentVariant.id) !== id) return;

    container.dataset.maxVariantId = id;
  }

  function clearVariantMaxReached(container, variantId) {
    if (!variantId) return;

    const id = String(variantId);
    maxReachedVariants.delete(id);

    if (container && String(container.dataset.maxVariantId || '') === id) {
      delete container.dataset.maxVariantId;
    }
  }

  async function checkVariantMaxQuantity(container, variant) {
    if (!variant || !variant.id) {
      return { allowed: true, quantity: 0, maxQuantity: CUST_MAX_QTY };
    }

    const variantId = String(variant.id);
    const maxQuantity = getVariantMaxQuantity(variant);

    // Never reached max → don't call cart.js
    if (!maxReachedVariants.has(variantId)) {
      return { allowed: true, quantity: 0, maxQuantity: maxQuantity };
    }

    // Previously maxed → verify actual cart quantity
    try {
      const cart = await getCart();
      const currentQuantity = getVariantQuantityInCart(cart, variantId);

      if (currentQuantity >= maxQuantity) {
        markVariantMaxReached(container, variantId);

        return {
          allowed: false,
          quantity: currentQuantity,
          maxQuantity: maxQuantity,
          cart: cart
        };
      }

      clearVariantMaxReached(container, variantId);

      return {
        allowed: true,
        quantity: currentQuantity,
        maxQuantity: maxQuantity,
        cart: cart
      };
    } catch (error) {
      console.warn('Cust Quick Add: max quantity check failed', error);

      return { allowed: true, quantity: 0, maxQuantity: maxQuantity };
    }
  }


  /* =========================================================
    REFRESH CART DRAWER
  ========================================================= */

  async function refreshCartDrawer(cart) {
    try {
      let drawerHTML = null;

      // Shopify sections API
      try {
        const response = await fetch(
          getRoot() + '?sections=cart-drawer-section',
          {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          }
        );

        if (response.ok) {
          const sections = await response.json();

          if (sections && sections['cart-drawer-section']) {
            drawerHTML = sections['cart-drawer-section'];
          }
        }
      } catch (error) {
        console.warn('Cust Quick Add drawer section error:', error);
      }

      // Fallback section request
      if (!drawerHTML) {
        try {
          const response = await fetch(
            getRoot() + '?section_id=cart-drawer-section',
            {
              method: 'GET',
              credentials: 'same-origin',
              cache: 'no-store',
              headers: { Accept: 'text/html' }
            }
          );

          if (response.ok) drawerHTML = await response.text();
        } catch (error) {
          console.warn('Cust Quick Add drawer fallback error:', error);
        }
      }

      // Replace drawer
      if (drawerHTML) {
        const doc = new DOMParser().parseFromString(drawerHTML, 'text/html');

        const newDrawer =
          doc.querySelector('#cart-drawer') ||
          doc.querySelector('cart-drawer') ||
          doc.querySelector('cart-drawer-component');

        const currentDrawer =
          document.querySelector('#cart-drawer') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-drawer-component');

        if (newDrawer && currentDrawer) {
          const newDialog = newDrawer.querySelector('dialog');
          const currentDialog = currentDrawer.querySelector('dialog');

          if (newDialog && currentDialog) {
            currentDialog.innerHTML = newDialog.innerHTML;
          } else {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
      }
      if (cart) updateCartCount(cart);

      // Notify theme
      const detail = { source: 'cust-quick-add', cart: cart };

      fire(document, 'cart:update', detail);
      fire(window, 'cart:update', detail);
      fire(document, 'cart:updated', detail);

      return true;
    } catch (error) {
      console.warn('Cust Quick Add drawer refresh error:', error);

      if (cart) {
        try {
          updateCartCount(cart);
        } catch (countError) {}
      }

      return false;
    }
  }


  /* =========================================================
    ADD TO CART
  ========================================================= */

  async function addToCart(container, variant) {
    if (!container || !variant || !variant.id) return;
    if (variant.available === false) return;

    const variantId = String(variant.id);
    const productId = container.dataset.productId || 'unknown';
    const pendingKey = productId + ':' + variantId;

    // Duplicate protection (same variant only)
    if (pendingVariantAdds.has(pendingKey)) return;

    // Newest request wins: older in-flight requests must not touch the UI
    const reqId = (container.__custReqId = (container.__custReqId || 0) + 1);
    const isLatest = function () {
      return container.__custReqId === reqId;
    };
    const showErr = function (c, message) {
      if (isLatest()) showMaxError(c, message);
    };

    pendingVariantAdds.add(pendingKey);
    container.dataset.adding = 'true';

    // NEW: show loader immediately
    setLoading(container, true);

    // NEW: cancel any pending auto-close
    clearAutoClose(container);

    hideMaxError(container);

    try {
      // Check max quantity
      const maxCheck = await checkVariantMaxQuantity(container, variant);

      if (!maxCheck.allowed) {
        markVariantMaxReached(container, variant.id);
        showErr(container, 'Maximum quantity reached for this variant.');
        return;
      }

      // Inventory zero
      if (maxCheck.maxQuantity <= 0) {
        markVariantMaxReached(container, variant.id);
        showErr(container, 'This variant is currently unavailable.');
        return;
      }

      /* ---------- CART ADD ---------- */

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const response = await fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json().catch(function () {
        return {};
      });

      /* ---------- ADD FAILED ---------- */

      if (!response.ok) {
        const errorMessage = String(
          data.description || data.message || ''
        ).toLowerCase();

        const isQuantityError =
          response.status === 422 ||
          errorMessage.includes('maximum') ||
          errorMessage.includes('max') ||
          errorMessage.includes('quantity') ||
          errorMessage.includes('inventory') ||
          errorMessage.includes('stock') ||
          errorMessage.includes('available');

        if (isQuantityError) {
          markVariantMaxReached(container, variant.id);

          showMaxError(
            container,
            data.description ||
              data.message ||
              'Maximum quantity reached for this variant.'
          );

          console.warn('Cust Quick Add: maximum reached for variant', variant.id);
          return;
        }

        showMaxError(
          container,
          data.description || data.message || 'Unable to add this item to cart.'
        );

        console.warn('Cust Quick Add: add to cart failed', data);
        return;
      }

      /* ---------- SUCCESS ---------- */

      hideMaxError(container);

      let cart = null;

      try {
        cart = await getCart();
      } catch (cartError) {
        console.warn('Cust Quick Add: cart refresh failed', cartError);
      }

      // Update cart bubble FIRST
      if (cart) {
        try {
          updateCartCount(cart);
        } catch (countError) {
          console.warn('Cust Quick Add: bubble update failed', countError);
        }
      }

      // Check max after add
      if (cart) {
        const currentQuantity = getVariantQuantityInCart(cart, variant.id);
        const maxQuantity = getVariantMaxQuantity(variant);

        if (currentQuantity >= maxQuantity) {
          markVariantMaxReached(container, variant.id);
        } else {
          clearVariantMaxReached(container, variant.id);
        }
      }

      // Open success popup (starts 5s auto close)
      try {
        if (isLatest()) openSuccess(container, variant, data);
      } catch (popupError) {
        console.warn('Cust Quick Add popup error:', popupError);
      }

      // Drawer refresh (not awaited)
      if (cart) {
        refreshCartDrawer(cart).catch(function (drawerError) {
          console.warn('Cust Quick Add drawer refresh error:', drawerError);
        });
      }

      // Cart added event
      fire(document, 'cust-quick-add:cart-added', {
        variant: variant,
        item: data,
        cart: cart
      });
    } catch (error) {
      console.error('Cust Quick Add Error:', error);
      showErr(container, 'Something went wrong. Please try again.');
    } finally {
      pendingVariantAdds.delete(pendingKey);

      // Only the newest request controls loader / adding state
      if (isLatest()) {
        container.dataset.adding = 'false';
        setLoading(container, false);
      }
    }
  }


  /* =========================================================
    VARIANT CHANGE
  ========================================================= */

  document.addEventListener(
    'change',
    function (event) {
      const input = event.target.closest(
        '.cust-quick-add-variant-picker input[type="radio"]'
      );

      if (!input) return;

      const container = getContainer(input);
      if (!container) return;

      // Stop the theme's <variant-picker> from re-rendering our picker
      event.stopImmediatePropagation();

      // Invalidate any older in-flight add (newest click wins)
      container.__custReqId = (container.__custReqId || 0) + 1;

      // Reset old state from previous click (max / sold out / error)
      hideMaxError(container);
      delete container.dataset.maxVariantId;

      // Always reflect the click in the UI, even for sold-out options
      input.checked = true;
      updateActiveState(container);

      const picker = getPicker(container);
      if (!picker) return;

      const selectedInputs = getSelectedInputs(picker);

      // Not all options selected yet
      if (selectedInputs.length !== getOptionCount(container)) {
        updateVariantTags(container, null);
        return;
      }

      const variant = findVariant(container);

      if (!variant) {
        updateVariantTags(container, null);
        return;
      }

      updatePrice(container, variant);
      updateVariantTags(container, variant);

      // Real sold-out check (from variant JSON, not stale HTML attribute)
      if (variant.available === false) {
        setLoading(container, false);
        return;
      }

      // Add immediately (loader is shown inside addToCart)
      addToCart(container, variant);
    },
    true
  );


  /* =========================================================
    OPEN QUICK ADD
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.cust-add-to-cart-btn');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const productCard = button.closest('product-card');
      if (!productCard) return;

      const productId = button.dataset.productId || productCard.dataset.productId;
      if (!productId) return;

      let quickAdd = productCard.querySelector('.cust-quick-add');

      if (!quickAdd) {
        try {
          quickAdd = document.querySelector(
            '.cust-quick-add[data-product-id="' +
              CSS.escape(String(productId)) +
              '"]'
          );
        } catch (error) {}
      }

      if (!quickAdd) return;

      let externalOverlay = productCard.querySelector('.cust-quick-add-overlayer');

      if (!externalOverlay) {
        try {
          externalOverlay = document.querySelector(
            '.cust-quick-add-overlayer[data-product-id="' +
              CSS.escape(String(productId)) +
              '"]'
          );
        } catch (error) {}
      }

      if (!externalOverlay) {
        const previous = quickAdd.previousElementSibling;

        if (previous && previous.classList.contains('cust-quick-add-overlayer')) {
          externalOverlay = previous;
        }
      }

      // Close other quick adds
      document
        .querySelectorAll('.cust-quick-add.is-active')
        .forEach(function (item) {
          if (item !== quickAdd) closeSuccess(item);
        });

      // Reset current
      resetQuickAdd(quickAdd);

      quickAdd.classList.add('is-active');
      if (externalOverlay) externalOverlay.classList.add('is-active');

      document.body.classList.add('cust-quick-add-body-open');
    },
    true
  );


  /* =========================================================
    INTERNAL OVERLAY CLOSE
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {
      const overlay = event.target.closest('.cust-quick-add-overlay');
      if (!overlay) return;

      event.preventDefault();
      event.stopPropagation();

      const container = getContainer(overlay);
      if (!container) return;

      closeSuccess(container);
    },
    true
  );


  /* =========================================================
    CLOSE BUTTON
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '.cust-quick-add [data-close-popup], .cust-quick-add .cust-quick-add-close'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const container = getContainer(button);
      if (container) closeSuccess(container);
    },
    true
  );


  /* =========================================================
    EXTERNAL OVERLAY CLOSE
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {
      const overlay = event.target.closest('.cust-quick-add-overlayer');
      if (!overlay) return;

      event.preventDefault();
      event.stopPropagation();

      let quickAdd = overlay.nextElementSibling;

      if (!quickAdd || !quickAdd.classList.contains('cust-quick-add')) {
        const productId = overlay.dataset.productId;

        if (productId) {
          try {
            quickAdd = document.querySelector(
              '.cust-quick-add[data-product-id="' +
                CSS.escape(String(productId)) +
                '"]'
            );
          } catch (error) {}
        }
      }

      if (!quickAdd || !quickAdd.classList.contains('cust-quick-add')) {
        quickAdd = document.querySelector('.cust-quick-add.is-active');
      }

      if (quickAdd) {
        closeSuccess(quickAdd);
      } else {
        overlay.classList.remove('is-active');
        document.body.classList.remove('cust-quick-add-body-open');
      }
    },
    true
  );


  /* =========================================================
    VIEW CART
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.cust-quick-add-view-cart');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const container = getContainer(button);
      if (container) closeSuccess(container);

      document
        .querySelectorAll('.cust-quick-add-overlayer.is-active')
        .forEach(function (overlay) {
          overlay.classList.remove('is-active');
        });

      requestAnimationFrame(function () {
        // Horizon cart drawer
        const trigger = document.querySelector(
          '[data-testid="cart-drawer-trigger"]'
        );

        if (trigger) {
          trigger.click();
          return;
        }

        // Other cart triggers
        const cartTrigger =
          document.querySelector('[ref="cartBubble"]') ||
          document.querySelector('[data-cart-drawer-trigger]');

        if (cartTrigger) {
          cartTrigger.click();
          return;
        }

        // Drawer
        const drawer =
          document.querySelector('#cart-drawer') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-drawer-component');

        if (drawer && typeof drawer.open === 'function') {
          try {
            drawer.open();
            return;
          } catch (error) {}
        }

        // Dialog fallback
        const dialog = drawer ? drawer.querySelector('dialog') : null;

        if (dialog && typeof dialog.showModal === 'function') {
          try {
            if (!dialog.open) dialog.showModal();
            return;
          } catch (error) {}
        }

        // Final fallback
        window.location.href = getRoot() + 'cart';
      });
    },
    true
  );


  /* =========================================================
    ESCAPE
  ========================================================= */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const active = document.querySelector('.cust-quick-add.is-active');
    if (active) closeSuccess(active);
  });


  /* =========================================================
    INITIALIZE
  ========================================================= */

  function initialize(container) {
    if (!container) return;

    saveOriginalPicker(container);

    container.dataset.adding = 'false';
    delete container.dataset.maxVariantId;

    setLoading(container, false); // NEW: make sure loader is off

    const picker = getPicker(container);

    if (picker) {
      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = false;
        input.removeAttribute('checked');
        input.dataset.previousChecked = 'false';
        input.dataset.currentChecked = 'false';
      });

      picker
        .querySelectorAll('.cust-quick-add-option-label')
        .forEach(function (label) {
          label.classList.remove('is-selected');
          label.classList.remove('is-max-reached');
        });

      picker
        .querySelectorAll('.cust-quick-add-current-value')
        .forEach(function (element) {
          element.textContent = '';
        });
    }

    updateActiveState(container);
    hideMaxError(container);

    const initialVariant = getInitialVariant(container);

    if (initialVariant) {
      updatePrice(container, initialVariant);
      updateVariantTags(container, initialVariant);
    } else {
      updateVariantTags(container, null);
    }
  }

  function initializeAll() {
    document.querySelectorAll('.cust-quick-add').forEach(function (container) {
      try {
        initialize(container);
      } catch (error) {
        console.error('Cust Quick Add initialize error:', error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }


  /* =========================================================
    SHOPIFY THEME EVENTS
  ========================================================= */

  ['shopify:section:load', 'shopify:block:select', 'shopify:section:reorder'].forEach(
    function (eventName) {
      document.addEventListener(eventName, function () {
        try {
          initializeAll();
        } catch (error) {
          console.error('Cust Quick Add ' + eventName + ' error:', error);
        }
      });
    }
  );


  /* =========================================================
    GLOBAL FUNCTIONS
  ========================================================= */

  window.resetCustQuickAddVariants = resetQuickAdd;
  window.closeCustQuickAddSuccess = closeSuccess;
  window.closeAllCustQuickAddSuccess = closeAllSuccess;
  window.updateCustQuickAddCartCount = updateCartCount;
  window.refreshCustQuickAddCartDrawer = refreshCartDrawer;
  window.updateCustQuickAddTags = updateVariantTags;
})();
// variant-chnage
// quick-add-open
  (function () {
    'use strict';

    if (window.__CUST_QUICK_ADD_OPEN__) {
      return;
    }

    window.__CUST_QUICK_ADD_OPEN__ = true;

    function closeQuickAdd(quickAdd, overlay) {
      if (quickAdd) {
        quickAdd.classList.remove('is-active');
      }

      if (overlay) {
        overlay.classList.remove('is-active');
      }
    }

    document.addEventListener('click', function (event) {
      const button = event.target.closest('.cust-add-to-cart-btn');

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const productCard = button.closest('product-card');

      if (!productCard) {
        return;
      }

      const productId =
        button.dataset.productId ||
        productCard.dataset.productId;

      if (!productId) {
        return;
      }

      let quickAdd = null;
      let overlay = null;

      let element = productCard.nextElementSibling;

      while (element) {
        if (
          element.matches &&
          element.matches('.cust-quick-add-overlayer')
        ) {
          overlay = element;
        }

        if (
          element.matches &&
          element.matches('.cust-quick-add')
        ) {
          const popupProductId =
            element.dataset.productId;

          if (
            !popupProductId ||
            popupProductId === String(productId)
          ) {
            quickAdd = element;
            break;
          }
        }

        if (
          element.matches &&
          element.matches('product-card')
        ) {
          break;
        }

        element = element.nextElementSibling;
      }

      if (!quickAdd) {
        quickAdd =
          document.querySelector(
            '.cust-quick-add[data-product-id="' +
              CSS.escape(String(productId)) +
              '"]'
          );
      }

      if (!overlay && quickAdd) {
        overlay =
          quickAdd.previousElementSibling;

        if (
          !overlay ||
          !overlay.classList.contains(
            'cust-quick-add-overlayer'
          )
        ) {
          overlay = null;
        }
      }

      if (!quickAdd) {
        console.warn(
          'Cust Quick Add not found:',
          productId
        );

        return;
      }

      /*
       * Close all other quick add popups
       */

      document
        .querySelectorAll(
          '.cust-quick-add.is-active'
        )
        .forEach(function (popup) {
          popup.classList.remove(
            'is-active'
          );
        });

      document
        .querySelectorAll(
          '.cust-quick-add-overlayer.is-active'
        )
        .forEach(function (item) {
          item.classList.remove(
            'is-active'
          );
        });

      /*
       * Open current quick add
       */

      quickAdd.classList.add(
        'is-active'
      );

      if (overlay) {
        overlay.classList.add(
          'is-active'
        );
      }
    });


    /*
     * Close on external overlay click
     */

    document.addEventListener(
      'click',
      function (event) {
        const overlay =
          event.target.closest(
            '.cust-quick-add-overlayer'
          );

        if (!overlay) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        let quickAdd =
          overlay.nextElementSibling;

        if (
          !quickAdd ||
          !quickAdd.classList.contains(
            'cust-quick-add'
          )
        ) {
          quickAdd =
            document.querySelector(
              '.cust-quick-add.is-active'
            );
        }

        closeQuickAdd(
          quickAdd,
          overlay
        );
      }
    );
  })();
// quick-add-open

// cart-drawer
document.addEventListener("click", function (event) {
  const dots = event.target.closest(".remove-dots");
  const close = event.target.closest(".remove-close");

  if (dots) {
    const toggle = dots.closest(".remove-button-toggle");
    if (!toggle) return;

    const row = toggle.closest("tr");
    const quantity = row?.querySelector(".cart-items__quantity");

    toggle.classList.add("active");
    quantity?.classList.add("active");
  }

  if (close) {
    const toggle = close.closest(".remove-button-toggle");
    if (!toggle) return;

    const row = toggle.closest("tr");
    const quantity = row?.querySelector(".cart-items__quantity");

    toggle.classList.remove("active");
    quantity?.classList.remove("active");
  }
});
function cartRemoveBtn(btn){
  const dots = btn.closest(".remove-dots");
  const close = btn.closest(".remove-close");

  if (dots) {
    const toggle = dots.closest(".remove-button-toggle");
    if (!toggle) return;

    const row = toggle.closest("tr");
    const quantity = row?.querySelector(".cart-items__quantity");

    toggle.classList.add("active");
    quantity?.classList.add("active");
  }

  if (close) {
    const toggle = close.closest(".remove-button-toggle");
    if (!toggle) return;

    const row = toggle.closest("tr");
    const quantity = row?.querySelector(".cart-items__quantity");

    toggle.classList.remove("active");
    quantity?.classList.remove("active");
  }
};



// cart-drawer

// date
  function getDaySuffix(day) {
    if (day > 3 && day < 21) return 'th';

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  function addWeekdays(date, daysToAdd) {
    const result = new Date(date);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      result.setDate(result.getDate() + 1);

      const day = result.getDay();

      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  function updateDeliveryDate() {
    const deliveryElements = document.querySelectorAll("p.delivery-date");
        // console.log("called...!")
    if (!deliveryElements.length) return;
        // console.log("--->",deliveryElements)

    const today = new Date();

    const startDate = addWeekdays(today, 3);
    const endDate = addWeekdays(today, 5);

    const startDay = startDate.getDate();
    const endDay = endDate.getDate();

    const startMonth = startDate.toLocaleString("default", {
      month: "short"
    });

    const endMonth = endDate.toLocaleString("default", {
      month: "short"
    });

    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    const startSuffix = getDaySuffix(startDay);
    const endSuffix = getDaySuffix(endDay);

    const deliveryText =
      `Delivery in between ${startDay}${startSuffix} ${startMonth} ${startYear} to ${endDay}${endSuffix} ${endMonth} ${endYear}`;

    deliveryElements.forEach(function(element) {
      element.textContent = deliveryText;
      element.classList.add("show");
    });
  }

  updateDeliveryDate();

// date



(function () {
  function getOriginalSlides(slideshow) {
    return Array.from(
      slideshow.querySelectorAll('slideshow-slide')
    ).filter(function (slide) {
      return (
        !slide.hasAttribute('data-clone') &&
        !slide.classList.contains('clone') &&
        !slide.classList.contains('is-clone')
      );
    });
  }

  function updateGalleryIndicators(gallery) {
    if (!gallery) return;

    var slideshow = gallery.querySelector('slideshow-component');
    var indicators = gallery.querySelectorAll('.card-gallery-indicator');

    if (!slideshow || !indicators.length) return;

    var slides = getOriginalSlides(slideshow);

    if (!slides.length) return;

    var activeIndex = -1;

    slides.forEach(function (slide, index) {
      if (slide.getAttribute('aria-hidden') === 'false') {
        activeIndex = index;
      }
    });

    /*
     * Fallback:
     * If aria-hidden is not available, find the slide
     * which is actually visible inside the slideshow.
     */
    if (activeIndex === -1) {
      var slideshowRect = slideshow.getBoundingClientRect();

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();

        var visible =
          rect.right > slideshowRect.left &&
          rect.left < slideshowRect.right &&
          rect.width > 0;

        if (visible) {
          activeIndex = index;
        }
      });
    }

    if (activeIndex === -1) return;

    indicators.forEach(function (indicator, index) {
      indicator.classList.toggle(
        'active',
        index === activeIndex
      );
    });
  }

  function updateAllGalleries() {
    document
      .querySelectorAll('.card-gallery')
      .forEach(function (gallery) {
        updateGalleryIndicators(gallery);
      });
  }

  /*
   * Attach observer to every slideshow.
   * This also works for related products that are loaded later.
   */
  function observeSlideshows() {
    document
      .querySelectorAll('slideshow-component')
      .forEach(function (slideshow) {
        if (slideshow.dataset.indicatorObserverAttached === 'true') {
          return;
        }

        slideshow.dataset.indicatorObserverAttached = 'true';

        var observer = new MutationObserver(function () {
          var gallery = slideshow.closest('.card-gallery');

          if (gallery) {
            updateGalleryIndicators(gallery);
          }
        });

        observer.observe(slideshow, {
          subtree: true,
          attributes: true,
          attributeFilter: [
            'aria-hidden',
            'class'
          ]
        });
      });
  }

  /*
   * Main observer:
   * Detects dynamically inserted related-product cards.
   */
  var galleryObserver = new MutationObserver(function (mutations) {
    var shouldUpdate = false;

    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        shouldUpdate = true;
      }
    });

    if (!shouldUpdate) return;

    observeSlideshows();
    updateAllGalleries();
  });

  function init() {
    observeSlideshows();
    updateAllGalleries();

    galleryObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /*
   * Normal page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
   * Shopify Theme Editor / dynamically rendered sections
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(function () {
        observeSlideshows();
        updateAllGalleries();
      }, 100);
    }
  );

  /*
   * Shopify section rendering
   */
  document.addEventListener(
    'shopify:section:reorder',
    function () {
      setTimeout(function () {
        observeSlideshows();
        updateAllGalleries();
      }, 100);
    }
  );

  /*
   * Small delay helps when Horizon finishes initializing
   * the slideshow after the card has been inserted.
   */
  window.addEventListener('load', function () {
    setTimeout(function () {
      observeSlideshows();
      updateAllGalleries();
    }, 300);
  });
})();



// document.addEventListener("DOMContentLoaded",()=>{
//   if(location.pathname.includes("/collections/")){

//   }
// })



//{% comment %} =============== Low Power mode code ============ {% endcomment %}

  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video');
    if(location.pathname.includes("/blogs/")) return
    if (!videos.length) return;

    const tryPlay = (video) => {
      if (video.paused) {
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {});
        }
      }
    };

    // Initial attempt
    videos.forEach((v) => tryPlay(v));

    // iOS-approved user interaction fallback
    const interactionEvents = ['touchstart', 'click', 'pointerdown'];

    const onUserInteraction = () => {
      videos.forEach((v) => tryPlay(v));
      interactionEvents.forEach((evt) => document.removeEventListener(evt, onUserInteraction));
    };

    interactionEvents.forEach((evt) => document.addEventListener(evt, onUserInteraction, { once: true }));

    // Resume if Safari pauses it (common in Low Power Mode)
    videos.forEach((video) => {
      video.addEventListener('pause', () => {
        setTimeout(() => tryPlay(video), 500);
      });
    });
  });

//{% comment %} =============== Low Power mode code ============ {% endcomment %}
const origFetch = window.fetch;
 
  window.fetch = async (...args) => {

    const res = await origFetch(...args);

    const url = typeof args[0] === 'string' ? args[0] : args[0].url;
 
    if (res.ok && url.includes("/cart/")) {
        setTimeout(() => {
          const deliveryDatenew = document.querySelector(".delivery-date");

          if (deliveryDatenew) {
            deliveryDatenew.classList.add("show");
            // console.log("trigger");
            updateDeliveryDate();
            // console.log("done");
          }
        }, 800);
      }

        return res;

      };


        